import { __awaiter } from 'tslib';
import * as i2 from '@ngrx/store';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Inject, Input, NgModule } from '@angular/core';
import { filter, combineLatest, map, startWith, take, tap, switchMap, first } from 'rxjs/operators';
import { LoadLeagueOnceAction, getLeague, entryAvailable, getGameAccountDescriptions, distinct, LoadLeaguesOnceAction, getLeagues, LoadMetaRankRankingAction, getMetaRankRanking, LoadPlayersOnceAction, getPlayers, LoadTeamsOnceAction, getTeams } from '@play/state';
import { find, isUndefined, filter as filter$1, orderBy, keyBy, forEach } from 'lodash';
import { combineLatest as combineLatest$1, BehaviorSubject, of } from 'rxjs';
import { isTeam, isLongRunning, isInProgress, isUpcoming, isFinished, getStartDate, getEndDate, getPlayerCount, isCancelled } from '@play/utility/league';
import * as i1 from '@play/common';
import { BASE_CONFIG, CommonsDateModule, CommonsComponentModule, CommonsRestrictionsModule } from '@play/common';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@play/translate';
import { TranslationModule } from '@play/translate';
import { cond, T } from 'ramda';
import { LeagueContestantTypes } from '@play/api-typings';
import * as i1$1 from '@play/api-client';
import { playersToDictionary } from '@play/utility/player';
import { teamsToDictionary } from '@play/utility/team';

function LeagueInformationComponent_div_0_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelement(3, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵelement(9, "format-date", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 2, "league-information:start-time"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("date", ctx_r12.league.timeline.inProgress.begin);
} }
function LeagueInformationComponent_div_0_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelement(3, "span", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵelement(9, "format-date", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 2, "league-information:check-in-time"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("date", ctx_r13.league.timeline.checkIn.begin);
} }
function LeagueInformationComponent_div_0_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelement(3, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵelement(9, "format-date", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 2, "league-information:late-sign-up-time"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("date", ctx_r14.league.timeline.lateSignUp.begin);
} }
function LeagueInformationComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵtemplate(2, LeagueInformationComponent_div_0_div_1_div_2_Template, 10, 4, "div", 12);
    i0.ɵɵtemplate(3, LeagueInformationComponent_div_0_div_1_div_3_Template, 10, 4, "div", 12);
    i0.ɵɵtemplate(4, LeagueInformationComponent_div_0_div_1_div_4_Template, 10, 4, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.league.timeline.inProgress.begin);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.hasCheckInPhase());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.hasLateSignUpPhase());
} }
function LeagueInformationComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "league-information:game"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.league.gameName, " ");
} }
function LeagueInformationComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "league-information:mode"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.league.mode, " ");
} }
const _c0$2 = function (a0) { return { count: a0 }; };
function LeagueInformationComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const maxLosses_r15 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "league-information:elimination"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 4, "league-information:after-n-losses", i0.ɵɵpureFunction1(7, _c0$2, maxLosses_r15)), " ");
} }
function LeagueInformationComponent_div_0_div_7_span_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementEnd();
} }
function LeagueInformationComponent_div_0_div_7_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, LeagueInformationComponent_div_0_div_7_span_4_span_2_Template, 2, 0, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const map_r17 = ctx.$implicit;
    const last_r18 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", map_r17, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !last_r18);
} }
function LeagueInformationComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LeagueInformationComponent_div_0_div_7_span_4_Template, 3, 2, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "league-informatiwn:maps"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r8.getMapParameters());
} }
function LeagueInformationComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "a", 27);
    i0.ɵɵlistener("click", function LeagueInformationComponent_div_0_div_8_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); ctx_r20.goToPrizeBox(); return false; });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "league-information:prizepool"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.league.prizePool, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, "league-information:more-details"));
} }
function LeagueInformationComponent_div_0_div_9_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "league-information:schedule"));
} }
const _c1$1 = function (a0) { return { index: a0 }; };
function LeagueInformationComponent_div_0_div_9_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "format-date", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const round_r27 = ctx.$implicit;
    const i_r28 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, "league-information:round-n", i0.ɵɵpureFunction1(5, _c1$1, i_r28 + 1)), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("date", round_r27.begin);
} }
function LeagueInformationComponent_div_0_div_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LeagueInformationComponent_div_0_div_9_ng_container_2_div_1_Template, 4, 7, "div", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const leagueSchedule_r22 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", leagueSchedule_r22);
} }
function LeagueInformationComponent_div_0_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "league-information:planned-schedule"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "league-information:schedule-unavailable"), " ");
} }
function LeagueInformationComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, LeagueInformationComponent_div_0_div_9_span_1_Template, 3, 3, "span", 29);
    i0.ɵɵtemplate(2, LeagueInformationComponent_div_0_div_9_ng_container_2_Template, 2, 1, "ng-container", 26);
    i0.ɵɵtemplate(3, LeagueInformationComponent_div_0_div_9_span_3_Template, 6, 6, "span", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const leagueSchedule_r22 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", leagueSchedule_r22);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", leagueSchedule_r22);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !leagueSchedule_r22);
} }
const _c2$1 = function (a0, a1, a2) { return { min: a0, max: a1, type: a2 }; };
function LeagueInformationComponent_div_0_div_11_li_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "league-information:team-size-requirement", i0.ɵɵpureFunction3(4, _c2$1, ctx_r30.teamSizeRestriction.params.minmembers, ctx_r30.teamSizeRestriction.params.maxmembers, ctx_r30.teamSizeRestriction.params.type)), " ");
} }
const _c3$1 = function (a0) { return { gameId: a0 }; };
function LeagueInformationComponent_div_0_div_11_li_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const description_r39 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "league-information:gameaccount-required", i0.ɵɵpureFunction1(4, _c3$1, description_r39.name)), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "league-information:ac2-required"), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "a", 36);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "league-information:anticheat-required"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "common:esl-anticheat"), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "a", 37);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "league-information:premium-required"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "common:premium"), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "league-information:warlog-description"), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "a", 38);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const trustedRestriction_r40 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "league-information:trusted-required"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(5, 5, "common:trusted-level"), " ", trustedRestriction_r40.params.mintrustlevel, " ");
} }
function LeagueInformationComponent_div_0_div_11_li_14_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 39);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const leagueid_r46 = ctx.$implicit;
    const ctx_r45 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r45.alternateLeagues[leagueid_r46].uri, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r45.alternateLeagues[leagueid_r46].name.full);
} }
function LeagueInformationComponent_div_0_div_11_li_14_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LeagueInformationComponent_div_0_div_11_li_14_ng_container_3_div_1_Template, 3, 2, "div", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const restriction_r41 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", restriction_r41.params.leagueids);
} }
function LeagueInformationComponent_div_0_div_11_li_14_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r41 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", restriction_r41.params.countryNames.join(", "), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_14_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r41 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 4, "sign-up-progress:residence"), ": ", restriction_r41.params.countryNames.join(", "), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(5, 6, "sign-up-progress:citizenship"), ": ", restriction_r41.params.nationalityNames.join(", "), " ");
} }
const _c4 = function (a0, a1, a2, a4, a5, a6) { return { teampositions: a0, minmembers: a1, team: a2, leagueids: "", gender: a4, leagueidcsv: a5, minage: a6 }; };
function LeagueInformationComponent_div_0_div_11_li_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, LeagueInformationComponent_div_0_div_11_li_14_ng_container_3_Template, 2, 1, "ng-container", 26);
    i0.ɵɵtemplate(4, LeagueInformationComponent_div_0_div_11_li_14_div_4_Template, 2, 1, "div", 26);
    i0.ɵɵtemplate(5, LeagueInformationComponent_div_0_div_11_li_14_div_5_Template, 6, 8, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r41 = ctx.$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 4, "sign-up-progress:" + restriction_r41.type + "-description", i0.ɵɵpureFunction6(7, _c4, restriction_r41.params && (restriction_r41.params.team_positions ? restriction_r41.params.team_positions.join(",") : ""), restriction_r41.params ? restriction_r41.params.minmembers : null, ctx_r37.isTeamLeague() ? 1 : 0, restriction_r41.params ? restriction_r41.params.gender : null, restriction_r41.params && restriction_r41.params.leagueidcsv ? restriction_r41.params.leagueidcsv.join(",") : "", restriction_r41.params ? restriction_r41.params.minage : null)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", restriction_r41.type === "alternateLeague" && restriction_r41.params && ctx_r37.alternateLeagues);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r41.params && restriction_r41.params.countries && !restriction_r41.params.nationalities);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r41.params && restriction_r41.params.countries && restriction_r41.params.nationalities);
} }
function LeagueInformationComponent_div_0_div_11_li_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r50 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "league-information:cocTownHallLevel-minmax", restriction_r50.params), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_15_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r50 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "league-information:cocTownHallLevel-max", restriction_r50.params), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_15_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r50 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "league-information:cocTownHallLevel-min", restriction_r50.params), " ");
} }
function LeagueInformationComponent_div_0_div_11_li_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵtemplate(1, LeagueInformationComponent_div_0_div_11_li_15_div_1_Template, 3, 4, "div", 26);
    i0.ɵɵtemplate(2, LeagueInformationComponent_div_0_div_11_li_15_div_2_Template, 3, 4, "div", 26);
    i0.ɵɵtemplate(3, LeagueInformationComponent_div_0_div_11_li_15_div_3_Template, 3, 4, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r50 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r50.params.min && restriction_r50.params.max);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !restriction_r50.params.min && restriction_r50.params.max);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r50.params.min && !restriction_r50.params.max);
} }
function LeagueInformationComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 32);
    i0.ɵɵtemplate(5, LeagueInformationComponent_div_0_div_11_li_5_Template, 3, 8, "li", 33);
    i0.ɵɵtemplate(6, LeagueInformationComponent_div_0_div_11_li_6_Template, 3, 6, "li", 34);
    i0.ɵɵtemplate(7, LeagueInformationComponent_div_0_div_11_li_7_Template, 3, 3, "li", 33);
    i0.ɵɵtemplate(8, LeagueInformationComponent_div_0_div_11_li_8_Template, 6, 6, "li", 33);
    i0.ɵɵtemplate(9, LeagueInformationComponent_div_0_div_11_li_9_Template, 6, 6, "li", 33);
    i0.ɵɵtemplate(10, LeagueInformationComponent_div_0_div_11_li_10_Template, 3, 3, "li", 33);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtemplate(12, LeagueInformationComponent_div_0_div_11_li_12_Template, 6, 7, "li", 33);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵtemplate(14, LeagueInformationComponent_div_0_div_11_li_14_Template, 6, 14, "li", 34);
    i0.ɵɵtemplate(15, LeagueInformationComponent_div_0_div_11_li_15_Template, 4, 3, "li", 33);
    i0.ɵɵpipe(16, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 10, "league-information:requirements"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r11.league.signUp.teamRequirements && ctx_r11.isTeamLeague() && ctx_r11.teamSizeRestriction);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.restrictionDescriptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isAc2Enabled());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isWireEnabled());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isPremiumRequired());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 12, ctx_r11.hasCoCWarLogRestriction$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 14, ctx_r11.trustedRestriction$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r11.restrictions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(16, 16, ctx_r11.cocTownHallLevelRestriction$));
} }
function LeagueInformationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, LeagueInformationComponent_div_0_div_1_Template, 5, 3, "div", 4);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, LeagueInformationComponent_div_0_div_3_Template, 5, 4, "div", 5);
    i0.ɵɵtemplate(4, LeagueInformationComponent_div_0_div_4_Template, 5, 4, "div", 5);
    i0.ɵɵtemplate(5, LeagueInformationComponent_div_0_div_5_Template, 6, 9, "div", 5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵtemplate(7, LeagueInformationComponent_div_0_div_7_Template, 5, 4, "div", 5);
    i0.ɵɵtemplate(8, LeagueInformationComponent_div_0_div_8_Template, 8, 7, "div", 5);
    i0.ɵɵtemplate(9, LeagueInformationComponent_div_0_div_9_Template, 4, 3, "div", 6);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵtemplate(11, LeagueInformationComponent_div_0_div_11_Template, 17, 18, "div", 7);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵelementStart(13, "div", 8);
    i0.ɵɵelementStart(14, "a", 9);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.league.type == "cup" || ctx_r0.league.type == "premiership" || ctx_r0.league.type == "swiss" || ctx_r0.league.type == "ffa");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.league.gameName !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.league.mode !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 9, ctx_r0.maxLosses$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.hasMapParameters());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.league.prizePool !== null && ctx_r0.league.prizePool !== "" && ctx_r0.league.prizePool);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 11, ctx_r0.leagueSchedule$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.restrictions.length || ctx_r0.isPremiumRequired() || ctx_r0.isAnticheatEnabled() || i0.ɵɵpipeBind1(12, 13, ctx_r0.trustedRestriction$) || ctx_r0.isTeamLeague());
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 15, "league-information:goto-rules"));
} }
function LeagueInformationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "league-information:nothing-here"));
} }
function LeagueInformationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r57 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", error_r57, "\n");
} }
function LeagueInformationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 41);
} }
class LeagueInformationComponent {
    constructor(restrictionTransformerService, store, config) {
        this.restrictionTransformerService = restrictionTransformerService;
        this.store = store;
        this.config = config;
        this.restrictionDescriptions = [];
        this.sortedSupportedRestrictions = [
            "logo",
            "inCountryList",
            "residence_nationality",
            "alternateLeague",
            "ga_team_positions",
            "gender",
            "minage",
            "photo",
            "country",
            "date",
            "fullname",
            "homepage",
            "isadmin",
            "memberinleague",
            "school",
            "whitelist",
        ];
        this.timezone = this.config.timezone;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe(filter(entryAvailable));
        this.gameAccountDescriptions$ = this.store.select(getGameAccountDescriptions);
        this.gameAccountDescriptions$
            .pipe(distinct(descriptions => descriptions.entry), combineLatest(this.league$), filter(([descriptions, league]) => Boolean(descriptions && league.entry)), map(([descriptions, league]) => {
            return descriptions.filter(description => {
                return Boolean(find(league.entry.restrictions, res => res.type === "gameaccount" && res.params.type === description.type));
            });
        }))
            .subscribe(descriptions => {
            this.restrictionDescriptions = descriptions;
        });
        this.refreshLeagueData();
        this.isLoading$ = combineLatest$1(this.league$, this.gameAccountDescriptions$).pipe(map(data => {
            return data.filter(entry => entry && entry.loading && !entry.entry).length !== 0;
        }), startWith(true));
        this.hasError$ = combineLatest$1(this.league$, this.gameAccountDescriptions$).pipe(map(data => {
            const [league, descriptions] = data;
            return league.error || descriptions.error ? "An error occurred. Sorry." : null;
        }));
        this.isReady$ = combineLatest$1(this.isLoading$, this.hasError$).pipe(map(([loading, error]) => Boolean(!loading && !error)));
        this.leagueSchedule$ = this.league$.pipe(map(league => league.entry), filter(league => !isUndefined(league.rounds)), map(league => league.rounds));
        this.maxLosses$ = this.league$.pipe(map(league => league.entry), filter(league => typeof league.maxLosses !== "undefined" &&
            league.maxLosses !== null &&
            league.maxLosses !== 0), map(league => league.maxLosses));
        this.trustedRestriction$ = this.league$.pipe(map(league => find(league.entry.restrictions, restriction => restriction.type === "trustlevel")));
        this.hasCoCWarLogRestriction$ = this.league$.pipe(map(league => find(league.entry.restrictions, restriction => restriction.type === "cocIsWarLogPublic")));
        this.cocTownHallLevelRestriction$ = this.league$.pipe(map(league => find(league.entry.restrictions, restriction => restriction.type === "cocTownHallLevel")));
    }
    getTeamSizeRestriction(restrictions) {
        const teamSizeRestriction = find(restrictions, restriction => restriction.type === "teamSize");
        if (!teamSizeRestriction) {
            return null;
        }
        return this.restrictionTransformerService.transformTeamSizeWithParams(teamSizeRestriction);
    }
    filterAndSortRestrictions(restrictions) {
        const filteredRestrictions = this.restrictionTransformerService.countryCodeToCountryName(filter$1(restrictions, ({ type }) => this.sortedSupportedRestrictions.indexOf(type) !== -1));
        return orderBy(filteredRestrictions, [
            (restriction) => {
                const index = this.sortedSupportedRestrictions.indexOf(restriction.type) + 1;
                if (index === 0) {
                    return this.sortedSupportedRestrictions.length + 1;
                }
                return index;
            },
            (restriction) => {
                return restriction.type;
            },
        ], ["asc", "asc"]);
    }
    getAlternateLeagues(restrictions) {
        const alternateLeague = find(restrictions, ["type", "alternateLeague"]);
        if (alternateLeague) {
            const { params: { leagueids }, } = alternateLeague;
            this.store.dispatch(new LoadLeaguesOnceAction(leagueids));
            return this.store
                .select(getLeagues(leagueids))
                .pipe(filter(leagues => leagues.size && leagues.every(({ loading }) => !loading) && leagues.every(entryAvailable)), map(leagues => leagues.toArray().map(({ entry }) => entry)), take(1))
                .toPromise();
        }
        return Promise.resolve([]);
    }
    refreshLeagueData() {
        this.league$.subscribe((league) => __awaiter(this, void 0, void 0, function* () {
            this.league = league.entry;
            const restrictions = league.entry ? league.entry.restrictions : [];
            this.teamSizeRestriction = this.getTeamSizeRestriction(restrictions);
            this.restrictions = this.filterAndSortRestrictions(restrictions);
            const alternateLeagues = yield this.getAlternateLeagues(restrictions);
            this.alternateLeagues = keyBy(alternateLeagues, "id");
        }));
    }
    isPremiumRequired() {
        return (this.league.hasOwnProperty("signUp") &&
            this.league.signUp.hasOwnProperty("premiumRequired") &&
            this.league.signUp.premiumRequired);
    }
    isAnticheatEnabled() {
        return this.league.anticheatEnabled;
    }
    isWireEnabled() {
        return this.isAnticheatEnabled() && !this.isAc2Enabled();
    }
    isAc2Enabled() {
        return this.isAnticheatEnabled() && this.league.enabledFeatures.indexOf("ac2") !== -1;
    }
    hasCheckInPhase() {
        return (this.league.hasOwnProperty("timeline") &&
            this.league.timeline.hasOwnProperty("checkIn") &&
            this.league.timeline.checkIn.hasOwnProperty("begin"));
    }
    hasLateSignUpPhase() {
        return (this.league.hasOwnProperty("timeline") &&
            this.league.timeline.hasOwnProperty("lateSignUp") &&
            this.league.timeline.lateSignUp.hasOwnProperty("begin"));
    }
    hasChallengeParameters() {
        return this.league.hasOwnProperty("challenge") && this.league.challenge.hasOwnProperty("parameters");
    }
    hasElimination() {
        return (typeof this.league.maxLosses !== "undefined" &&
            this.league.maxLosses !== null &&
            this.league.maxLosses !== 0);
    }
    getMapParameters() {
        if (!this.hasChallengeParameters()) {
            return [];
        }
        const maps = this.league.challenge.parameters.filter(function (item) {
            return item.name === "map" && item.setBy === "both";
        });
        return maps.reduce(function (previous, current) {
            return previous.concat(current.options);
        }, []);
    }
    hasMapParameters() {
        return this.hasChallengeParameters && this.getMapParameters().length > 0;
    }
    goToPrizeBox() {
        let offset = -70; // height of pane-title
        let element = document.querySelector(".league-text-prize");
        if (!element) {
            return;
        }
        do {
            offset += element.offsetTop;
            element = element.offsetParent;
        } while (element);
        window.scrollTo(0, offset);
    }
    isTeamLeague() {
        return isTeam(this.league);
    }
}
LeagueInformationComponent.ɵfac = function LeagueInformationComponent_Factory(t) { return new (t || LeagueInformationComponent)(i0.ɵɵdirectiveInject(i1.RestrictionTransformerService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(BASE_CONFIG)); };
LeagueInformationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeagueInformationComponent, selectors: [["league-information"]], inputs: { leagueId: "leagueId" }, decls: 8, vars: 12, consts: [["class", "c-league-information", 4, "ngIf"], ["class", "league", 4, "ngIf"], ["class", "loading-container", 4, "ngIf"], [1, "c-league-information"], ["class", "c-league-information__wrapper c-league-information__wrapper--timeline c-league-information__wrapper--isolate", 4, "ngIf"], ["class", "c-league-information__wrapper", 4, "ngIf"], ["class", "c-league-information__wrapper c-league-information__schedule-times", 4, "ngIf"], ["class", "c-league-information__wrapper c-league-information__requirements", 4, "ngIf"], [1, "c-league-information__wrapper", "c-league-information__rules"], ["href", "rules"], [1, "c-league-information__wrapper", "c-league-information__wrapper--timeline", "c-league-information__wrapper--isolate"], [1, "c-league-information__schedule", "o-grid", "o-grid--inside"], ["class", "o-grid__item u-1/3", 4, "ngIf"], [1, "o-grid__item", "u-1/3"], [1, "c-league-information__schedule__entry", "o-flag"], [1, "o-flag__figure"], [1, "c-league-information__schedule__icon", "esl-icon", "esl_league-time"], [1, "o-flag__body"], [1, "c-league-information__schedule__title"], [1, "c-league-information__schedule__value"], [3, "date"], [1, "c-league-information__schedule__icon", "esl-icon", "esl_league-signup"], [1, "c-league-information__schedule__icon", "esl-icon", "esl_league-wait"], [1, "c-league-information__wrapper"], [1, "c-league-information__title"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["href", "", 3, "click"], [1, "c-league-information__wrapper", "c-league-information__schedule-times"], ["class", "c-league-information__title", 4, "ngIf"], ["class", "c-league-information__wrapper", 4, "ngFor", "ngForOf"], [1, "c-league-information__wrapper", "c-league-information__requirements"], [1, "c-league-information__requirements__list"], ["class", "c-league-information__requirement", 4, "ngIf"], ["class", "c-league-information__requirement", 4, "ngFor", "ngForOf"], [1, "c-league-information__requirement"], ["href", "https://play.eslgaming.com/anticheat"], ["href", "https://play.eslgaming.com/premium"], ["href", "https://play.eslgaming.com/playercard_portal"], ["target", "_blank", 3, "href"], [1, "league"], [1, "loading-container"]], template: function LeagueInformationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LeagueInformationComponent_div_0_Template, 17, 17, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, LeagueInformationComponent_div_2_Template, 3, 3, "div", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, LeagueInformationComponent_div_4_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵtemplate(6, LeagueInformationComponent_div_6_Template, 1, 0, "div", 2);
        i0.ɵɵpipe(7, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 4, ctx.isReady$) && ctx.league);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.league && i0.ɵɵpipeBind1(3, 6, ctx.isReady$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 8, ctx.hasError$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 10, ctx.isLoading$));
    } }, directives: [i3.NgIf, i1.FormatDateComponent, i3.NgForOf], pipes: [i3.AsyncPipe, i2$1.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeagueInformationComponent, [{
        type: Component,
        args: [{
                selector: "league-information",
                templateUrl: "./league-information.component.html",
                styleUrls: ["./league-information.component.scss"],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.RestrictionTransformerService }, { type: i2.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: [BASE_CONFIG]
            }] }]; }, { leagueId: [{
            type: Input
        }] }); })();

const _c0$1 = function (a0, a1) { return [a0, a1]; };
class DateTimeComponent {
    constructor(translate, formatter) {
        this.translate = translate;
        this.formatter = formatter;
    }
    ngOnChanges() {
        this.dateTimeTooltip = this.formatter.getFullDateTimeTz(this.dateTime);
        this.dateTimeText = cond([
            [
                isLongRunning,
                () => cond([
                    [isInProgress, () => this.translate.translate("league-date-time:long-running-ongoing", {})],
                    [T, () => this.formatter.formatDateTime(this.dateTime)],
                ])({ state: this.leagueState }),
            ],
            [
                T,
                () => cond([
                    [isInProgress, () => this.translate.translate("league-date-time:short-running-ongoing", {})],
                    [T, () => this.formatter.formatDateTime(this.dateTime)],
                ])({ state: this.leagueState }),
            ],
        ])({ type: this.leagueType });
    }
}
DateTimeComponent.ɵfac = function DateTimeComponent_Factory(t) { return new (t || DateTimeComponent)(i0.ɵɵdirectiveInject(i2$1.TranslateService), i0.ɵɵdirectiveInject(i1.FormatDate)); };
DateTimeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DateTimeComponent, selectors: [["league-date-time"]], inputs: { leagueType: "leagueType", leagueState: "leagueState", dateTime: "dateTime" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 6, consts: [[1, "c-league-date-time", 3, "ngClass", "tooltip"]], template: function DateTimeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$1, "c-league-date-time--" + ctx.leagueType, "c-league-date-time--" + ctx.leagueState))("tooltip", ctx.dateTimeTooltip);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.dateTimeText, "\n");
    } }, directives: [i3.NgClass, i1.TooltipDirective], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimeComponent, [{
        type: Component,
        args: [{
                selector: "league-date-time",
                templateUrl: "./date-time.component.html",
                styleUrls: ["./date-time.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2$1.TranslateService }, { type: i1.FormatDate }]; }, { leagueType: [{
            type: Input
        }], leagueState: [{
            type: Input
        }], dateTime: [{
            type: Input
        }] }); })();

const dateTimeTexts = {
    "league-date-time:long-running-ongoing": "Live Now",
    "league-date-time:long-running-finished": "Finished On {date}",
    "league-date-time:short-running-ongoing": "Ongoing",
    "league-date-time:short-running-finished": "Finished On {date}",
};

function LeagueListComponent_ng_container_0_a_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "league-ui:in-progress"));
} }
function LeagueListComponent_ng_container_0_a_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "format-date", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const league_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("date", ctx_r7.getStartDate(league_r5));
} }
function LeagueListComponent_ng_container_0_a_2_div_5_format_date_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "format-date", 14);
} if (rf & 2) {
    const league_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("date", ctx_r11.getEndDate(league_r5))("onlyDate", true);
} }
const _c0 = function (a1) { return { date: "", hasDate: a1 }; };
function LeagueListComponent_ng_container_0_a_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, LeagueListComponent_ng_container_0_a_2_div_5_format_date_3_Template, 1, 2, "format-date", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const league_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, "league-ui:finished-on", i0.ɵɵpureFunction1(5, _c0, ctx_r8.getEndDate(league_r5) ? 1 : 0)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.getEndDate(league_r5));
} }
function LeagueListComponent_ng_container_0_a_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} if (rf & 2) {
    const league_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap("icon-game-" + league_r5.gameId);
} }
const _c1 = function (a0) { return { live: a0 }; };
function LeagueListComponent_ng_container_0_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LeagueListComponent_ng_container_0_a_2_div_3_Template, 3, 3, "div", 6);
    i0.ɵɵtemplate(4, LeagueListComponent_ng_container_0_a_2_div_4_Template, 2, 1, "div", 6);
    i0.ɵɵtemplate(5, LeagueListComponent_ng_container_0_a_2_div_5_Template, 4, 7, "div", 6);
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, LeagueListComponent_ng_container_0_a_2_div_7_Template, 1, 2, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 10);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const league_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", league_r5.name.short)("href", league_r5.uri, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction1(11, _c1, ctx_r3.isInProgress(league_r5)));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("esl-icon s22 esl_label-esl-" + league_r5.skillLevel + " text-color-esl-" + league_r5.skillLevel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isInProgress(league_r5));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isUpcoming(league_r5));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isFinished(league_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showGameIcons);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(league_r5.name.short);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.getLeaguePlayers(league_r5));
} }
function LeagueListComponent_ng_container_0_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-tournament-list:no-past-leagues"), " ");
} }
const _c2 = function (a0, a1) { return { "loading-container": a0, "small": a1 }; };
function LeagueListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtemplate(2, LeagueListComponent_ng_container_0_a_2_Template, 12, 13, "a", 3);
    i0.ɵɵtemplate(3, LeagueListComponent_ng_container_0_p_3_Template, 3, 3, "p", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const data_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c2, data_r2.loading, ctx_r0.compact));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", data_r2.leagues);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isUserLeagueList && (!data_r2.loading && !data_r2.leagues && !data_r2.leagues.length));
} }
function LeagueListComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r1.linkUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.linkTitle);
} }
const _c3 = function (a0, a1) { return { leagues: a0, loading: a1 }; };
class LeagueListComponent {
    constructor(leagueResource, playerResource, translate) {
        this.leagueResource = leagueResource;
        this.playerResource = playerResource;
        this.translate = translate;
        this.loading$ = new BehaviorSubject(true);
        this.isInProgress = isInProgress;
        this.isUpcoming = isUpcoming;
        this.isFinished = isFinished;
        this.getStartDate = getStartDate;
        this.getEndDate = getEndDate;
    }
    ngOnInit() {
        const currentPrefix = Drupal.settings.legacy_content.prefix;
        this.normalizedPrefix = currentPrefix.charAt(0) === "/" ? currentPrefix : "/" + currentPrefix;
        const query = {
            states: ["finished"],
            path: this.path || this.normalizedPrefix,
            types: this.leagueTypes,
            skillLevels: this.skillLevels,
            tags: this.tags,
            limit: {
                total: this.limitTotal,
            },
            includeHidden: this.includeHidden,
        };
        switch (this.timeframe) {
            case 0:
                query.states = ["inprogress", "upcoming"];
                query.limit.inProgress = this.limitInProgress;
                break;
            case 2:
                query.states = ["upcoming"];
                break;
        }
        if (this.isUserLeagueList) {
            this.getUserLeagues(query);
        }
        else {
            this.getLeagues(query);
        }
    }
    getLeaguePlayers(league) {
        const { contestantType } = league;
        const translation = contestantType === LeagueContestantTypes.Team ? "common:n-teams" : "common:n-players";
        return this.translate.translate(translation, { count: getPlayerCount(league) });
    }
    getLeagues(query) {
        this.loading$.next(true);
        this.leagues$ = this.leagueResource.queryLeagues(query).pipe(map((leagues) => {
            leagues = leagues.filter(league => !isCancelled(league));
            if (query.states.indexOf("finished") !== -1) {
                leagues = this.sortClosedLeagues(leagues);
            }
            else {
                leagues = this.sortLeagues(leagues);
            }
            if (this.sortBy === "name") {
                leagues = this.sortByName(leagues);
            }
            return leagues;
        }), tap(() => {
            this.loading$.next(false);
        }));
    }
    getUserLeagues(query) {
        this.loading$.next(true);
        const criteria = this.buildCriteria(query);
        this.leagues$ = this.playerResource.getLeaguesOfPlayer(Drupal.settings.user.id, criteria).pipe(map(leagues => leagues.map(league => league.leagueId)), map((leagueIds) => {
            const groupedLeagueIds = leagueIds.reduce((acc, curr) => {
                if (acc[acc.length - 1].length < 100) {
                    acc[acc.length - 1].push(curr);
                }
                else {
                    acc.push([curr]);
                }
                return acc;
            }, [[]]);
            return groupedLeagueIds.map(ids => this.leagueResource.queryLeagues({ leagueIds: ids }));
        }), switchMap(apiRequests => combineLatest$1(apiRequests)), map(arr => [].concat.apply([], arr)), tap(() => {
            this.loading$.next(false);
        }));
    }
    sortClosedLeagues(leagues) {
        leagues.sort((leagueA, leagueB) => {
            const endLeagueA = new Date(getEndDate(leagueA)).getTime();
            const endLeagueB = new Date(getEndDate(leagueB)).getTime();
            if (endLeagueA < endLeagueB) {
                return 1;
            }
            else if (endLeagueA > endLeagueB) {
                return -1;
            }
            else {
                if (leagueA.name.full < leagueB.name.full) {
                    return 1;
                }
                else {
                    return -1;
                }
            }
        });
        return leagues;
    }
    sortLeagues(leagues) {
        leagues.sort((leagueA, leagueB) => {
            const beginLeagueA = new Date(getStartDate(leagueA)).getTime();
            const beginLeagueB = new Date(getStartDate(leagueB)).getTime();
            if (beginLeagueA < beginLeagueB) {
                return -1;
            }
            else if (beginLeagueA > beginLeagueB) {
                return 1;
            }
            else {
                if (leagueA.id < leagueB.id) {
                    return -1;
                }
                else {
                    return 1;
                }
            }
        });
        return leagues;
    }
    sortByName(leagues) {
        leagues.sort((a, b) => {
            if (a.name.short < b.name.short) {
                return -1;
            }
            if (a.name.short > b.name.short) {
                return 1;
            }
            return 0;
        });
        return leagues;
    }
    buildCriteria(query) {
        const criteriaKeys = ["types", "states", "skillLevels", "limit", "path", "portals", "tags"];
        const criteria = {};
        forEach(criteriaKeys, key => {
            if (query[key]) {
                criteria[key] = query[key];
            }
        });
        return criteria;
    }
}
LeagueListComponent.ɵfac = function LeagueListComponent_Factory(t) { return new (t || LeagueListComponent)(i0.ɵɵdirectiveInject(i1$1.LeagueResource), i0.ɵɵdirectiveInject(i1$1.PlayerResource), i0.ɵɵdirectiveInject(i2$1.TranslateService)); };
LeagueListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeagueListComponent, selectors: [["league-list"]], inputs: { showGameIcons: "showGameIcons", compact: "compact", linkTitle: "linkTitle", linkUrl: "linkUrl", isUserLeagueList: "isUserLeagueList", path: "path", leagueTypes: "leagueTypes", timeframe: "timeframe", skillLevels: "skillLevels", tags: "tags", limitInProgress: "limitInProgress", limitTotal: "limitTotal", includeHidden: "includeHidden", sortBy: "sortBy" }, decls: 4, vars: 9, consts: [[4, "ngIf"], [3, "href", 4, "ngIf"], [1, "league-list", "cups", 3, "ngClass"], [3, "title", "href", "ngClass", 4, "ngFor", "ngForOf"], [3, "title", "href", "ngClass"], [1, "skill-level"], ["class", "date", 4, "ngIf"], [1, "game-icon"], [3, "class", 4, "ngIf"], [1, "title"], [1, "players"], [1, "date"], [3, "date"], [3, "date", "onlyDate", 4, "ngIf"], [3, "date", "onlyDate"], [3, "href"]], template: function LeagueListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LeagueListComponent_ng_container_0_Template, 4, 6, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵtemplate(3, LeagueListComponent_a_3_Template, 2, 2, "a", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction2(6, _c3, i0.ɵɵpipeBind1(1, 2, ctx.leagues$), i0.ɵɵpipeBind1(2, 4, ctx.loading$)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.linkUrl);
    } }, directives: [i3.NgIf, i3.NgClass, i3.NgForOf, i1.FormatDateComponent], pipes: [i3.AsyncPipe, i2$1.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeagueListComponent, [{
        type: Component,
        args: [{
                selector: "league-list",
                templateUrl: "./list.component.html",
                styleUrls: ["./list.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.LeagueResource }, { type: i1$1.PlayerResource }, { type: i2$1.TranslateService }]; }, { showGameIcons: [{
            type: Input
        }], compact: [{
            type: Input
        }], linkTitle: [{
            type: Input
        }], linkUrl: [{
            type: Input
        }], isUserLeagueList: [{
            type: Input
        }], path: [{
            type: Input
        }], leagueTypes: [{
            type: Input
        }], timeframe: [{
            type: Input
        }], skillLevels: [{
            type: Input
        }], tags: [{
            type: Input
        }], limitInProgress: [{
            type: Input
        }], limitTotal: [{
            type: Input
        }], includeHidden: [{
            type: Input
        }], sortBy: [{
            type: Input
        }] }); })();

function LeagueRankingComponent_div_0_div_11_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
} }
function LeagueRankingComponent_div_0_div_11_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 13);
} }
function LeagueRankingComponent_div_0_div_11_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 14);
} }
function LeagueRankingComponent_div_0_div_11_img_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 15);
} }
function LeagueRankingComponent_div_0_div_11_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span");
    i0.ɵɵelementStart(2, "a", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const contestants_r11 = i0.ɵɵnextContext().ngIf;
    const contestant_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("icon icon-16 flag-", contestants_r11[contestant_r5.contestant_id].region, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "/player/", contestant_r5.contestant_id, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(contestants_r11[contestant_r5.contestant_id].nickname);
} }
function LeagueRankingComponent_div_0_div_11_div_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span");
    i0.ɵɵelementStart(2, "a", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const contestants_r11 = i0.ɵɵnextContext().ngIf;
    const contestant_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("icon icon-16 flag-", contestants_r11[contestant_r5.contestant_id].region, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "/team/", contestant_r5.contestant_id, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(contestants_r11[contestant_r5.contestant_id].name);
} }
function LeagueRankingComponent_div_0_div_11_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, LeagueRankingComponent_div_0_div_11_div_9_ng_container_1_Template, 4, 5, "ng-container", 1);
    i0.ɵɵtemplate(2, LeagueRankingComponent_div_0_div_11_div_9_ng_container_2_Template, 4, 5, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contestant_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", contestant_r5.contestant_type === "player");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", contestant_r5.contestant_type === "team");
} }
function LeagueRankingComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtemplate(2, LeagueRankingComponent_div_0_div_11_img_2_Template, 1, 0, "img", 7);
    i0.ɵɵtemplate(3, LeagueRankingComponent_div_0_div_11_img_3_Template, 1, 0, "img", 8);
    i0.ɵɵtemplate(4, LeagueRankingComponent_div_0_div_11_img_4_Template, 1, 0, "img", 9);
    i0.ɵɵtemplate(5, LeagueRankingComponent_div_0_div_11_img_5_Template, 1, 0, "img", 10);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, LeagueRankingComponent_div_0_div_11_div_9_Template, 3, 2, "div", 11);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contestant_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", contestant_r5.rank === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", contestant_r5.rank === 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", contestant_r5.rank === 3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", contestant_r5.rank > 3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", contestant_r5.rank, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(contestant_r5.points);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 7, ctx_r4.contestants$));
} }
function LeagueRankingComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, LeagueRankingComponent_div_0_div_11_Template, 11, 9, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ranking_r3 = ctx.ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "league-rankings:rank"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "league-rankings:points"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "league-rankings:contestant"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ranking_r3.ranking);
} }
function LeagueRankingComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r19 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", error_r19, "\n");
} }
function LeagueRankingComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 5);
    i0.ɵɵelement(12, "div", 18);
    i0.ɵɵelement(13, "div", 18);
    i0.ɵɵelement(14, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 5);
    i0.ɵɵelement(16, "div", 18);
    i0.ɵɵelement(17, "div", 18);
    i0.ɵɵelement(18, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 5);
    i0.ɵɵelement(20, "div", 18);
    i0.ɵɵelement(21, "div", 18);
    i0.ɵɵelement(22, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "league-rankings:rank"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, "league-rankings:points"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 7, "league-rankings:contestant"));
} }
class LeagueRankingComponent {
    constructor(store, translation) {
        this.store = store;
        this.translation = translation;
        this.contestants$ = of(null);
    }
    ngOnInit() {
        this.store.dispatch(new LoadMetaRankRankingAction(this.series, this.season, this.limit, this.offset));
        this.ranking$ = this.store.select(getMetaRankRanking(`${this.series}-${this.season}`)).pipe(filter(entryAvailable));
        this.ranking$.pipe(first()).subscribe(ranking => {
            const contestantIds = ranking.entry.ranking.map(r => r.contestant_id);
            const contestantType = ranking.entry.ranking[0].contestant_type;
            if (contestantIds.length) {
                switch (contestantType) {
                    case "team":
                        this.store.dispatch(new LoadTeamsOnceAction(contestantIds));
                        this.contestants$ = this.store.select(getTeams(contestantIds)).pipe(teamsToDictionary());
                        break;
                    case "player":
                        this.store.dispatch(new LoadPlayersOnceAction(contestantIds));
                        this.contestants$ = this.store.select(getPlayers(contestantIds)).pipe(playersToDictionary());
                        break;
                }
            }
        });
        this.isLoading$ = combineLatest$1([this.ranking$, this.contestants$]).pipe(map(data => {
            const [ranking, contestants] = data;
            return ranking.entry && ranking.loading && !ranking.entry && (!contestants || Object.keys(contestants).length === 0);
        }), startWith(true));
        this.hasError$ = combineLatest$1([this.ranking$, this.contestants$]).pipe(map(data => {
            const [ranking, contestants] = data;
            return !contestants && ranking.error ? this.translation.translate("commons:data-fetch-error", {}) : null;
        }));
    }
}
LeagueRankingComponent.ɵfac = function LeagueRankingComponent_Factory(t) { return new (t || LeagueRankingComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2$1.TranslateService)); };
LeagueRankingComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeagueRankingComponent, selectors: [["league-ranking"]], inputs: { series: "series", season: "season", limit: "limit", offset: "offset" }, decls: 6, vars: 9, consts: [["class", "ranking-table", 4, "ngIf"], [4, "ngIf"], [1, "ranking-table"], [1, "ranking-table__header"], ["class", "ranking-table__row", 4, "ngFor", "ngForOf"], [1, "ranking-table__row"], [1, "ranking-table__row__rank"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_gold_3.png", 4, "ngIf"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_silver_3.png", 4, "ngIf"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_bronze_3.png", 4, "ngIf"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_grey.png", 4, "ngIf"], ["class", "ranking-table__row__contestant", 4, "ngIf"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_gold_3.png"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_silver_3.png"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_bronze_3.png"], ["src", "https://cdn.eslgaming.com/misc/media/de/news/famfamfam/medal_grey.png"], [1, "ranking-table__row__contestant"], [3, "href"], [1, "c-skeleton__text"]], template: function LeagueRankingComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LeagueRankingComponent_div_0_Template, 12, 10, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, LeagueRankingComponent_div_2_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, LeagueRankingComponent_div_4_Template, 23, 9, "div", 0);
        i0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        let tmp_0_0 = null;
        i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(1, 3, ctx.ranking$)) == null ? null : tmp_0_0.entry);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 5, ctx.hasError$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 7, ctx.isLoading$));
    } }, directives: [i3.NgIf, i3.NgForOf], pipes: [i3.AsyncPipe, i2$1.TranslatePipe], styles: [".ranking-table[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(3,auto);grid-row-gap:8px;grid-column-gap:8px}.ranking-table__header[_ngcontent-%COMP%]{display:contents;font-weight:600}.ranking-table__row[_ngcontent-%COMP%]{display:contents}.ranking-table__row__rank[_ngcontent-%COMP%]{display:flex;align-items:center}.ranking-table__row__rank[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{margin-right:4px}.ranking-table__row__contestant[_ngcontent-%COMP%]{display:flex;align-items:center}.ranking-table__row__contestant[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-right:4px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeagueRankingComponent, [{
        type: Component,
        args: [{
                selector: "league-ranking",
                templateUrl: "./ranking.component.html",
                styleUrls: ["./ranking.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.Store }, { type: i2$1.TranslateService }]; }, { series: [{
            type: Input
        }], season: [{
            type: Input
        }], limit: [{
            type: Input
        }], offset: [{
            type: Input
        }] }); })();

class LeagueModule {
}
LeagueModule.ɵfac = function LeagueModule_Factory(t) { return new (t || LeagueModule)(); };
LeagueModule.ɵmod = i0.ɵɵdefineNgModule({ type: LeagueModule });
LeagueModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, TranslationModule, CommonsDateModule, CommonsComponentModule, CommonsRestrictionsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LeagueModule, { declarations: [DateTimeComponent, LeagueListComponent, LeagueRankingComponent, LeagueInformationComponent], imports: [CommonModule, TranslationModule, CommonsDateModule, CommonsComponentModule, CommonsRestrictionsModule], exports: [DateTimeComponent, LeagueListComponent, LeagueRankingComponent, LeagueInformationComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeagueModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslationModule, CommonsDateModule, CommonsComponentModule, CommonsRestrictionsModule],
                declarations: [DateTimeComponent, LeagueListComponent, LeagueRankingComponent, LeagueInformationComponent],
                exports: [DateTimeComponent, LeagueListComponent, LeagueRankingComponent, LeagueInformationComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of league
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DateTimeComponent, LeagueInformationComponent, LeagueListComponent, LeagueModule, LeagueRankingComponent, dateTimeTexts };
//# sourceMappingURL=play-league.js.map
